import React from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../firebase'
import { useAuth } from '../contexts/AuthContext'
import { useChat } from '../contexts/ChatContext'
import TchatAvatar from '../images/TchatAvatar.png'
import { useNav } from '../contexts/NavContext'

const ChatHistory = () => {
   const [chats, setChats] = React.useState([])
   const { dispatch } = useChat()
   const { user: cUser } = useAuth()
   const { toggleNav } = useNav()

   React.useEffect(() => {
      const getChats = () => {
         return onSnapshot(doc(db, "userChats", cUser.uid), (doc) => {
            setChats(doc.data())
         })
      }

      const unsubscribe = cUser.uid && getChats()
      return () => {
         unsubscribe?.();
      }
   }, [cUser.uid])

   const handleSelect = (userInfo) => {
      dispatch({ type: 'CHANGE_USER', payload: userInfo })
      toggleNav()
   }

   return (
      <div className='px-8 py-4'>
         {Object.entries(chats)?.sort(([, a], [, b]) => b.date - a.date).map(([uid, { lastMessage, userInfo }]) => (
            <div className='flex gap-4 items-center px-6 py-4 rounded-2xl hover:bg-dark-20 cursor-pointer' key={uid} onClick={() => handleSelect(userInfo)}>
               <img className='h-20 w-20 rounded-3xl border-2 border-purple-light' src={userInfo.photoURL || TchatAvatar} alt='user' />
               <div className='flex gap-2 flex-col'>
                  <span>{userInfo.displayName}</span>
                  <p className='text-2xl text-gray-300 font-light'>{lastMessage?.text}</p>
               </div>
            </div>
         ))}
      </div>
   )
}

export default ChatHistory